import React from "react";
import "./Custom.css";
import PropTypes from "prop-types";

const Card = ({ data }) => {
  const { icon, title, subtitle } = data;
  Card.propTypes = {
    data: PropTypes.object.isRequired, // Replace `object` with the correct type
  };
  return (
    <div className="why-us-item p-6 rounded-xl flex align-items-center justify-center">
      <div className="why-us-content">
        <div className=" mb-3  my-icon rounded-3xl">{icon}</div>
        <h4 className="font-semibold text-xl leading-6 heading ">{title}</h4>
        <p className="my-4 text-base font-normal paragraph ">{subtitle}</p>
        {/* <p class="mb-0 text-[#fbcb04] review-para paragraph !text-black">
          {review}
        </p> */}
      </div>
    </div>
  );
};

export default Card;
